module.exports = __webpack_public_path__ + "static/media/googleplay.e6fe412f.svg";